import { render, staticRenderFns } from "./UserSettingsPage.vue?vue&type=template&id=294c6d21&scoped=true"
import script from "./UserSettingsPage.vue?vue&type=script&lang=js"
export * from "./UserSettingsPage.vue?vue&type=script&lang=js"
import style0 from "./UserSettingsPage.vue?vue&type=style&index=0&id=294c6d21&prod&scoped=true&lang=css"
import style1 from "./UserSettingsPage.vue?vue&type=style&index=1&id=294c6d21&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294c6d21",
  null
  
)

export default component.exports